export { AlterarSenhaModal } from './AlterarSenha';
export { LoginModais } from './LoginModais';
